module.exports = __webpack_public_path__ + "media/images/earth-global-globe-planet-world-svgrepo-com-b0115c5af59f20a648ffd741be7f729e.svg";